import{a}from"./chunk-TR7CUFAV.js";import{m as r}from"./chunk-HBP5N4FR.js";r();function t({getTransactionsByHash:n}){return a({getTransactionsByHash:n}),null}export{t as a};
//# sourceMappingURL=chunk-RFRTZ543.js.map
